import { Component, input, model } from '@angular/core';
import type { OnyxOptional } from '@onyx/angular';
import { OnyxLoadingErrorComponent, OnyxSpinnerComponent } from '@onyx/angular';

@Component({
  selector: 'app-modal-loading-section',
  imports: [OnyxSpinnerComponent, OnyxLoadingErrorComponent],
  templateUrl: './modal-loading-section.component.html',
  styleUrl: './modal-loading-section.component.scss',
})
export class ModalLoadingSectionComponent {
  public readonly message = input<OnyxOptional<string>>();
  public readonly loading = input(false);
  public readonly error = model(false);
}
